import React from 'react'
import { motion } from 'framer-motion'

interface CardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  hover?: boolean
  animation?: {
    initial?: any
    animate?: any
    transition?: any
    whileHover?: any
  }
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  onClick, 
  hover = false,
  animation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 },
    whileHover: hover ? { y: -5, scale: 1.02 } : {}
  }
}) => {
  const baseClasses = "relative overflow-hidden rounded-2xl transition-all duration-300"
  const hoverClasses = hover ? "hover:shadow-xl cursor-pointer group" : ""
  const clickableClasses = onClick ? "cursor-pointer" : ""

  const cardContent = (
    <div
      className={`${baseClasses} ${hoverClasses} ${clickableClasses} ${className}`}
      style={{ 
        backgroundColor: 'var(--bg-card)',
        border: '1px solid var(--border-primary)',
        boxShadow: 'var(--shadow-md)'
      }}
      onClick={onClick}
    >
      {hover && <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"></div>}
      <div className="relative">
        {children}
      </div>
    </div>
  )

  if (animation) {
    return (
      <motion.div
        initial={animation.initial}
        animate={animation.animate}
        transition={animation.transition}
        whileHover={animation.whileHover}
      >
        {cardContent}
      </motion.div>
    )
  }

  return cardContent
}

export default Card
